import "./App.css";
import { Fragment } from "react";
import Header from "./components/Layouts/Header";
import AboutSection from "./components/Layouts/AboutSection";
import PortfolioSection from "./components/Layouts/PortfolioSection";
import ContactSection from "./components/Layouts/ContactSection";

function App() {
  return (
    <Fragment>
      <Header />
      <AboutSection />
      <PortfolioSection />
      <ContactSection />
    </Fragment>
  );
}

export default App;
